<app-page-breadcrumb pageTitle="Plantillas de correo"></app-page-breadcrumb>

@if (showCategoryModal) {
  <app-template-category-modal (closed)="onCategoryModalClosed()" />
}

<app-component-card>
  <!-- Toolbar -->
  <div class="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between mb-4">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 flex-1">
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
          Buscar
        </label>
        <input
          type="text"
          [(ngModel)]="filtroSearch"
          (ngModelChange)="buscar()"
          placeholder="Nombre o asunto..."
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500/20 focus:border-brand-300"
        />
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
          Estado
        </label>
        <select
          [(ngModel)]="filtroStatus"
          (ngModelChange)="onFilterChange()"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
        >
          <option value="">Todos</option>
          <option value="DRAFT">Borrador</option>
          <option value="ACTIVE">Activa</option>
          <option value="ARCHIVED">Archivada</option>
        </select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
          Categoría
        </label>
        <select
          [(ngModel)]="filtroCategoryId"
          (ngModelChange)="onFilterChange()"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
        >
          <option value="">Todas</option>
          @for (c of categories; track c.idCategory) {
            <option [value]="c.idCategory">{{ c.name }}</option>
          }
        </select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
          Visibilidad
        </label>
        <select
          [(ngModel)]="filtroVisibility"
          (ngModelChange)="buscar()"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
        >
          <option value="">Todas</option>
          <option value="PUBLIC">Públicas</option>
          <option value="PERSONAL">Personales</option>
        </select>
      </div>
    </div>

    <div class="flex flex-wrap items-center gap-2">
      <button
        type="button"
        (click)="limpiarFiltro()"
        class="px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
      >
        Limpiar
      </button>
      <ng-container *appHasPermission="'campaigns:edit'">
        <app-button variant="outline" (btnClick)="abrirCategorias()">Categorías</app-button>
      </ng-container>
      <ng-container *appHasPermission="'campaigns:create'">
        <app-button variant="primary" (btnClick)="nuevo()">+ Nueva plantilla</app-button>
      </ng-container>
    </div>
  </div>

  @if (error) {
    <p class="mb-3 text-sm text-error-600 dark:text-error-400">{{ error }}</p>
  }

  @if (loading) {
    <div class="flex justify-center py-8">
      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
    </div>
  } @else if (paginated.length === 0) {
    <p class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">
      No hay plantillas registradas.
    </p>
  } @else {
    <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 dark:bg-gray-800">
          <tr>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Nombre</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Asunto</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-40">Categoría</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-32">Estado</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-32">Visibilidad</th>
            <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-40">Última edición</th>
            <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400 w-44">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
          @for (t of paginated; track trackById($index, t)) {
            <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50">
              <td class="px-3 py-2 font-medium text-gray-900 dark:text-white">{{ t.name }}</td>
              <td class="px-3 py-2 text-gray-700 dark:text-gray-300 truncate max-w-xs">
                {{ t.subject || '—' }}
              </td>
              <td class="px-3 py-2 text-gray-600 dark:text-gray-400">
                {{ getCategoriaNombre(t.categoryId) }}
              </td>
              <td class="px-3 py-2">
                <app-badge [color]="statusColor(t.status)">{{ statusLabel(t.status) }}</app-badge>
              </td>
              <td class="px-3 py-2">
                <app-badge variant="solid" [color]="visibilityColor(t)" [startIcon]="visibilityIcon(t)">{{ visibilityLabel(t) }}</app-badge>
                @if (t.isPublic && !esMia(t)) {
                  <span class="block mt-0.5 text-[10px] text-gray-400 dark:text-gray-500">De otro usuario</span>
                }
              </td>
              <td class="px-3 py-2 text-gray-500 dark:text-gray-400">
                {{ t.updatedAt | date:'short' }}
              </td>
              <td class="px-3 py-2">
                <div class="flex items-center justify-end gap-1">
                  @if (esMia(t)) {
                    <button
                      type="button"
                      [appDisableWithoutPermission]="'campaigns:edit'"
                      (click)="editar(t)"
                      title="Editar"
                      class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                      </svg>
                    </button>
                  }
                  <button
                    type="button"
                    [appDisableWithoutPermission]="'campaigns:create'"
                    (click)="duplicar(t)"
                    title="Duplicar"
                    class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                    </svg>
                  </button>
                  @if (esMia(t) && t.status === 'DRAFT') {
                    <button
                      type="button"
                      [appDisableWithoutPermission]="'campaigns:edit'"
                      (click)="cambiarStatus(t, 'ACTIVE')"
                      title="Activar"
                      class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-success-600 dark:text-gray-400 dark:hover:bg-gray-700"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                      </svg>
                    </button>
                  }
                  @if (esMia(t) && t.status === 'ACTIVE') {
                    <button
                      type="button"
                      [appDisableWithoutPermission]="'campaigns:edit'"
                      (click)="cambiarStatus(t, 'ARCHIVED')"
                      title="Archivar"
                      class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-warning-600 dark:text-gray-400 dark:hover:bg-gray-700"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
                      </svg>
                    </button>
                  }
                  @if (esMia(t) && t.status === 'ARCHIVED') {
                    <button
                      type="button"
                      [appDisableWithoutPermission]="'campaigns:edit'"
                      (click)="cambiarStatus(t, 'DRAFT')"
                      title="Restaurar a borrador"
                      class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"/>
                      </svg>
                    </button>
                  }
                  @if (esMia(t)) {
                    <button
                      type="button"
                      [appDisableWithoutPermission]="'campaigns:delete'"
                      (click)="eliminar(t)"
                      title="Eliminar"
                      class="p-1.5 rounded-lg text-gray-500 hover:bg-error-50 hover:text-error-600 dark:text-gray-400 dark:hover:bg-error-500/10"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/>
                      </svg>
                    </button>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div class="mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
      <div class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
        <span>Mostrar</span>
        <select
          [(ngModel)]="pageSize"
          (ngModelChange)="onPageSizeChange()"
          class="px-2 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
        >
          @for (opt of PAGE_SIZE_OPTIONS; track opt) {
            <option [value]="opt">{{ opt }}</option>
          }
        </select>
        <span>de {{ globalTotalElements }} registros</span>
      </div>
      <div class="flex items-center gap-1">
        <button
          type="button"
          (click)="goToPage(globalPage - 1)"
          [disabled]="globalPage === 0"
          class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          Anterior
        </button>
        <span class="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-400">
          Página {{ globalPage + 1 }} de {{ globalTotalPages || 1 }}
        </span>
        <button
          type="button"
          (click)="goToPage(globalPage + 1)"
          [disabled]="globalPage + 1 >= globalTotalPages"
          class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          Siguiente
        </button>
      </div>
    </div>
  }
</app-component-card>
